import * as Immutable from "immutable";

import {
  WIDGET_LINK_TEXT_CHAR_LIMIT,
  WIDGET_BUTTON_LABEL_CHAR_LIMIT,
  WIDGET_LINK_STILL_WAITING_PROMPT_CHAR_LIMIT
} from "constants/messages";

import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class WidgetMessageRecord
 * @augments BaseMessageRecord
 */
class WidgetMessageRecord extends BaseMessageRecord({
  type: "widget",

  /** @memberof WidgetMessageRecord# */
  widgetUrl: "",
  inputsData: Immutable.OrderedMap({ "": "" }),
  inputsDataList: Immutable.List(),
  variablesData: Immutable.List(),
  linkText: "",
  linkSubtext: "",
  stillWaitingPrompt: ""
}) {}

/**
 * Validation
 */

/**
 * @param {WidgetMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
WidgetMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  // disable the save button if widgetUrl is empty or it does not begin with 'https://'
  if (message.widgetUrl.length <= 0 || !message.widgetUrl.startsWith("https://")) {
    invalidFields.add("widgetUrl");
  }

  if (message.linkText.length <= 0 || message.linkText.length > WIDGET_LINK_TEXT_CHAR_LIMIT) {
    invalidFields.add("linkText");
  }

  if (
    message.linkSubtext.length <= 0 ||
    message.linkSubtext.length > WIDGET_BUTTON_LABEL_CHAR_LIMIT
  ) {
    invalidFields.add("linkSubtext");
  }

  if (
    message.stillWaitingPrompt.length <= 0 ||
    message.stillWaitingPrompt.length > WIDGET_LINK_STILL_WAITING_PROMPT_CHAR_LIMIT
  ) {
    invalidFields.add("stillWaitingPrompt");
  }

  message.variablesData
    .filter(data => !data.get("variableId"))
    .forEach((data, i) => invalidFields.add(`invalidVariableId-${i}`));

  return Immutable.List(invalidFields);
};

export default WidgetMessageRecord;
